import { render, staticRenderFns } from "./orderComplete.vue?vue&type=template&id=330f7530&scoped=true&"
import script from "./orderComplete.vue?vue&type=script&lang=js&"
export * from "./orderComplete.vue?vue&type=script&lang=js&"
import style0 from "./orderComplete.vue?vue&type=style&index=0&id=330f7530&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "330f7530",
  null
  
)

export default component.exports